import { useLogout } from "utils/hooks";
import { toast } from "react-toastify";
import { User } from "types";
import { GROUP_USER_ROLES } from "utils/constants";

interface resendGroupInviteProps {
  groupId: string;
  member: User;
}

const useResendGroupInvite = () => {
  const { logOut } = useLogout();
  const resendGroupInvite = async ({
    groupId,
    member,
  }: resendGroupInviteProps) => {
    const { email, role } = member;

    console.log("Resend group invite - member data:", {
      email,
      role,
      member,
      GROUP_USER_ROLES,
    });

    let mutation;

    if (role === GROUP_USER_ROLES.MODERATOR) {
      console.log("Using MODERATOR mutation");
      mutation = `
          mutation {
            resendTherapistGroupInvite(
              groupId: "${groupId}",
              email: "${email}",
            )
          }
        `;
    } else if (role === GROUP_USER_ROLES.MEMBER) {
      console.log("Using MEMBER mutation");
      mutation = `
          mutation {
            resendPatientGroupInvite(
              groupId: "${groupId}",
              email: "${email}",
            )
          }
        `;
    } else {
      console.log("No matching role found, returning null. Role:", role);
      return null;
    }

    try {
      console.log("Resending group invite:", {
        groupId,
        email,
        role,
        mutation,
      });

      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: mutation,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const resData = await res.json();
      console.log("Resend group invite response:", {
        status: res.status,
        data: resData,
      });

      if (res.ok && !resData.errors) {
        toast("Invitation has been resent");
        return true;
      }

      if (res.ok && resData.errors) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
        return false;
      }

      if (!res.ok) {
        if (resData.errors && resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${
              resData.errors?.[0]?.message || "Unknown error"
            }`
          );
        }
        return false;
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    resendGroupInvite,
  };
};

export default useResendGroupInvite;
